const getUnitName = (currency: CashierCurrency, isUbtcEnabled: boolean) => {
  if (currency === 'BTC') {
    return isUbtcEnabled ? 'uBTC' : 'mBTC';
  }
  return currency;
};

export default getUnitName;
